import React, { Component, useCallback, useEffect, useState } from "react";
import { Card, Pagination, Button, ConfigProvider, Input, Upload, Select, Switch, Modal, Radio, Space,Cascader,DatePicker } from "antd";
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useHistory } from "react-router-dom";
import "./index.scss";
import zh_CN from "antd/es/locale/zh_CN";
import Collected from "images/collected.png";
import CollectWork from "images/collectWork.png";
import {getCitys ,getcodeValue} from 'utils/storage';
import moment from "moment";
const { confirm } = Modal;
const { TextArea } = Input;

export const RenderForm = ({ type, label, name, value, onChange, placeholder, options }) => {
  const citys = getCitys()
  const handleInputChange = useCallback((e) => {
    e.persist()
    console.log('------handleInputChange------', e.target.value);
    onChange(name, e.target.value)
  })

  const handleSelectChange = useCallback((e) => {
    console.log('------handleSelectChange------', e);
    onChange(name, e)
  })

  const handleRadioChange = useCallback((e) => {
    console.log('------handleRadioChange------', e);
    onChange(name, e.target.value)
  })
  const onChangeCity = (value, selectedOptions) => {
    console.log('selectedOptions',value, selectedOptions);
    let str = ''
    selectedOptions.map((item,index)=>{
      if(index!=selectedOptions.length-1){
        return str = `${str}${item.label}-`
      }else{
        return str = `${str}${item.label}`
      }
    })
    onChange(name, str)
  }
  const onChangeTime = (e) =>{
    console.log('eeeeeeeee',moment(e).format('YYYY-MM-DD'));
    onChange(name,e)
  }
  switch (type) {
    case 'select':
      return (
        <>
          <span className="form_label" >{label}:</span>
          <Select value={value} onChange={handleSelectChange} placeholder="请选择">
            {
              options.map(el => {
                return <Select.Option key={el.label} value={el.value} >{el.label}</Select.Option>
              })
            }
          </Select>
        </>
      )
    case 'radio':
      return (
        <>
          <span className="form_label" >{label}:</span>
          <Radio.Group onChange={handleRadioChange} value={value}>
            {
              options.map(el => {
                return <Radio checked={el.value == value} key={el.label} value={el.value} >{el.label}</Radio>
              })
            }
          </Radio.Group>
        </>
      )
      case 'Cascader':
      return (
        <>
          <span className="form_label" >{label}:</span>
          {/* <Radio.Group onChange={handleRadioChange} value={value}>
            {
              options.map(el => {
                return <Radio checked={el.value == value} key={el.label} value={el.value} >{el.label}</Radio>
              })
            }
          </Radio.Group> */}
          <Cascader
            placeholder="请选择地区"
            allowClear={false}
            options={citys}
            onChange={onChangeCity}
          />

          
        </>
      )
      case 'time':
        return (
          <>
            <span className="form_label" >{label}:</span>
            <DatePicker onChange={onChangeTime} style={{width:'240px'}} locale={zh_CN}/>
          </>
        )
    default:
      return (
        <>
          <span className="form_label" >{label}:</span>
          {type === 'textarea'
            ? <TextArea type="text" name={name} value={value} onChange={handleInputChange} placeholder={placeholder} />
            : <Input type="text" rows={4} name={name} value={value} onChange={handleInputChange} placeholder={placeholder} />
          }
        </>
      )
  }
}

// export function PublishJob({onChange}) {

//   return confirm({
//     title: '发布新职位',
//     centered: true,
//     width: 784,
//     modalRender: CustomModal(formConfig(),onChange),
//     mask: true,
//     onOk() {
//       console.log('OK');
//     },
//     onCancel() {
//       console.log('Cancel');
//     },
//   });
// }

export const CustomModal = ({ data = [], onChange, onOk, onCancel }) => {

  return (
    <div className="mask_container">
      <div className="custom_modal">
        <div className="modal_header">
          <span className="title_bar"></span><span className="header_title">发布新职位</span>
        </div>
        <div className="modal_content">
          <ul className='base_info_list'>
            {
              data.length && data.map((item, index) => {
                return (
                  <li className='base_info_item' key={index}>
                    {
                      RenderForm({ ...item, onChange: onChange })
                    }
                  </li>
                )
              })
            }

          </ul>
        </div>
        <div className="modal_footer">
          <div className="cancel_save">
            <span className="cancel_btn" onClick={onCancel}>取消</span>
            <span className="save_btn" onClick={onOk}>发布</span>
          </div>
        </div>

      </div>
    </div>
  )
}

export function JobItem(props) {
  const {
    job: {
      job, //职位名称
      workArea, //工作地区
      auditMechanismName, //公司名称
      recruitsNumber, //招聘人数
      salary, //薪资
      workExperience, //工作年限
      degree, //学历
      auditMechanismIntroduce, //企业性质
      auditMechanismScale, //企业人数
      welfare, //福利待遇
      publishingStatus,//职位状态
      jobInformationState, //该条信息状态
      id = 100,
    },
    handleJobDetail,
    handleOpenOrClose, 
    handleEdit,
    handleDel
  } = props;
  // console.log('publishingStatuspublishingStatus',props,publishingStatus);
  
  return (
    <div
      className={"job_item_box"}
      onClick={(e) => {
        handleJobDetail(e, id);
      }}
    >
      <section className={"job_item_header"}>
        <div className={"job_item_title"}>
          <div className={"job_item_left"}>
            <span className={"job_item_name"}>{job}</span>
            <span className={"job_item_area"}>「{workArea}」</span>
            <span
              // className={"job_item_delivery"}
              className={
                // publishingStatus? 
                  'job_audit_success'
                  // : 'job_under_review'
              }
            >
              {jobInformationState == 0 ? "提交" : jobInformationState == 1 ? "通过" : jobInformationState == 2 ? "未通过" : jobInformationState == 3 ? "草稿" : ''}
            </span>
          </div>
          <div>
            <span className={"job_item_company_name"}>{auditMechanismName}</span>
          </div>
          <div className="operate_btns">
            {jobInformationState == 1
              ? 
              <div className="open_close">
                <Switch defaultChecked ={!publishingStatus} checked={!publishingStatus} onClick={(data,e)=>{ handleOpenOrClose(data,e,id)}} />
              </div>
                : ''} 
            <div className='edit_del'>
              <div className="edit_info" onClick={(e) => handleEdit(e, id)}></div>
              <div className="del_info" onClick={(e) => handleDel(e, id)}></div>
            </div>
          </div>
        </div>
        <div className={"job_item_info"}>
          <div className={"job_item_left"}>
            <span className={"job_item_salary"}>{salary}</span>
            <span className={"job_item_work_year"}>{workExperience}</span>
            <span className={"job_item_split"}>|</span>
            {/* <span className={"job_item_education"}>{degree==1?'大专':degree==2?'本科':degree==3?'研究生':degree==4?'不限':''}</span> */}
            <span className={"job_item_education"}>{getcodeValue('edu_lev_code',degree)}</span>
          </div>
          <div>
            <span className={"job_item_recruitment_num"}>
              招聘人数：{recruitsNumber}
            </span>
            {/* <span className={"job_item_enterprise_type"}>{auditMechanismIntroduce}</span> */}
            <span className={"job_item_enterprise_num"}>{auditMechanismScale}</span>
          </div>
        </div>
      </section>
      <section className={"job_item_footer"}>
        <div className={"job_item_left"}>
          <span className={"job_item_treatment"}>{welfare}</span>
        </div>
      </section>
    </div>
  );
}
